import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Board.css";

const COLORS = ["#9B5DE5", "#3A86FF", "#00BB7E", "#FFBE0B"];

const ICONS = [
  "question-fill.svg",
  "x-fill.svg",
  "warning-fill.svg",
  "prohibit-fill.svg",
];

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const [fontLoaded, setFontLoaded] = useState(false);
  const [iconSize, setIconSize] = useState(() =>
    window.innerWidth <= 600 ? 60 : 110
  );
  const [iconHeight, setIconHeight] = useState(() =>
    window.innerWidth <= 600 ? 50 : 84
  );
  const [imgSize, setImgSize] = useState(() =>
    window.innerWidth <= 600 ? 30 : 50
  );
  const [gap, setGap] = useState(() => (window.innerWidth <= 600 ? 8 : 12));

  // Font loading effect
  useEffect(() => {
    const font = new FontFace(
      "Monigue",
      "url('/public/fonts/Monigue/Monigue.woff2') format('woff2')"
    );
    font
      .load()
      .then(() => {
        document.fonts.add(font);
        setFontLoaded(true);
      })
      .catch(() => {
        setFontLoaded(true);
      });

    const timeout = setTimeout(() => {
      setFontLoaded(true);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  // Responsive sizes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setIconSize(60);
        setIconHeight(50);
        setImgSize(30);
        setGap(8);
      } else {
        setIconSize(110);
        setIconHeight(84);
        setImgSize(50);
        setGap(12);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <h1
        className={fontLoaded ? "font-loaded" : "font-loading"}
        style={{
          fontSize: window.innerWidth <= 600 ? 120 : 180,
          margin: 0,
          fontFamily: "Monigue, Arial, sans-serif",
          fontWeight: 400,
          lineHeight: 1,
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        }}
      >
        404
      </h1>

      <div
        style={{
          display: "flex",
          gap: gap,
          borderRadius: 200,
          background: "#fff",
          margin: "24px 0 32px 0",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: window.innerWidth <= 600 ? "90vw" : "100%",
        }}
      >
        {ICONS.map((icon, i) => (
          <span
            key={i}
            style={{
              width: iconSize,
              height: iconHeight,
              borderRadius: 200,
              background: COLORS[i],
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxSizing: "border-box",
              userSelect: "none",
              opacity: 0.6,
            }}
          >
            <img
              src={`/icons/${icon}`}
              alt=""
              style={{
                width: imgSize,
                height: imgSize,
                filter: "brightness(0) invert(1)",
              }}
              draggable={false}
            />
          </span>
        ))}
      </div>

      <h2
        style={{
          fontSize: window.innerWidth <= 600 ? 18 : 24,
          fontWeight: 600,
          margin: "0 0 8px 0",
          color: "#1C1C1E",
        }}
      >
        Page not found
      </h2>

      <p
        style={{
          fontSize: window.innerWidth <= 600 ? 14 : 16,
          color: "#666",
          margin: "0 0 32px 0",
          maxWidth: 400,
        }}
      >
        Looks like this puzzle piece doesn't exist. Let's get you back to the game!
      </p>

      <button className="button-main" onClick={() => navigate("/")}>
        Back to Matchset
      </button>
    </div>
  );
};

export default NotFoundPage;
